<script>
import CkeditorWidget from "@/components/widgets/editor.vue";
import ModalHistoryJawaban from "@/router/views/assesmen-hc/text/modal_history_jawaban.vue";
import Swal from "sweetalert2";
import axios from "axios";

export default {
  components: {
    CkeditorWidget,
    ModalHistoryJawaban,
  },
  props: {
    soalStats: Object,
    currentQuestion: Object,
    idJadwal: String,
    idJadwalPeserta: String,
    nextSoal: Function,
    last_page: Number,
    index_soal: Number,
    status_pengerjaan: Number,
    getListSoalRedis: Function,
  },
  emits: ["modalProgressFinal"],
  data() {
    return {
      BACKEND_URL: process.env.VUE_APP_BACKEND_URL,
      contentTinymce: "",
      modalHistoryJawaban: false,
      refreshTable: 0,
    };
  },
  mounted() {
    this.contentTinymce = this.currentQuestion?.jawaban_peserta?.jawaban ?? "";
  },
  watch: {
    currentQuestion(newVal) {
      this.contentTinymce = newVal?.jawaban_peserta?.jawaban ?? "";
    },
  },
  methods: {
    saveAnswers() {
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });
      let self = this;
      var config_store_data = {
        method: "post",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "peserta/jadwal-peserta/simpan-jawaban-text",
        data: {
          jawaban: this.contentTinymce,
          id_soal: this.currentQuestion.idsoal,
          id_jadwal: this.idJadwal,
          id_jadwal_peserta: this.idJadwalPeserta,
          is_simulasi: localStorage.getItem("is_simulasi"),
          uniqueId: localStorage.getItem("uniqueId"),
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token_peserta,
        },
      };
      axios(config_store_data)
        .then(function (response) {
          console.log("Jawaban berhasil disimpan:", response.data);
          Swal.close();
          Swal.fire({
            icon: "success",
            title: "Jawaban berhasil disimpan!",
            text: "Jawaban berhasil disimpan di server.",
            timer: 2000,
            timerProgressBar: true,
          });
          if (typeof self.getListSoalRedis === "function") {
            self.getListSoalRedis();
          }
        })
        .catch(function (error) {
          Swal.close();
          console.error("Error saat menyimpan jawaban:", error);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Terjadi kesalahan saat menyimpan jawaban.",
          });
        });
      this.refreshTable++;
    },
    handleJawabanSelected(data) {
      this.contentTinymce = data.jawaban;
      this.modalHistoryJawaban = false;
    },
  },
};
</script>

<template>
  <div v-if="currentQuestion" class="mym-question-body">
    <!-- HEADER NUMBER -->
    <div class="mym-card-case mb-3" v-if="currentQuestion?.soal_text != null">
      <div class="mym-card-jumbotron-header">
        <div class="mym-card-jumbotron-icon text-light">
          <i class="fa fa-file-alt"></i>
        </div>

        <h3 class="mym-card-jumbotron-title">Studi Kasus</h3>
      </div>

      <div class="mym-card-jumbotron-content">
        {{ currentQuestion?.soal_text }}
      </div>
    </div>

    <div class="mym-question-navigation">
      <div class="mym-qn-header">
        <div class="mym-question-number">
          Soal
          <span class="mym-actived-number">{{ index_soal }}</span> /
          {{ soalStats?.total }}
        </div>
      </div>

      <div class="mym-question-section">
        <div class="mb-2">
          <img
            v-if="currentQuestion?.soal_image"
            :src="BACKEND_URL + currentQuestion?.soal_image"
            class="mym-question-image"
          />
          <div class="mym-question-text">
            {{ currentQuestion?.pertanyaan }}
          </div>
        </div>
      </div>
    </div>

    <!-- PANEL JAWABAN FULL WIDTH -->
    <div class="card w-100">
      <div class="card-header bg-primary text-white">
        <h5 class="card-title text-white mb-0">Jawaban</h5>
      </div>
      <div class="card-body">
        <CkeditorWidget v-model="contentTinymce" />
      </div>
      <div class="card-footer d-flex justify-content-between">
        <button
          type="button"
          class="btn btn-secondary"
          @click="modalHistoryJawaban = true"
        >
          History Jawaban
        </button>
        <button
          type="button"
          class="btn btn-success"
          @click="saveAnswers()"
        >
          Simpan Jawaban
        </button>
      </div>
    </div>

    <!-- FOOTER NAVIGASI -->
    <div class="mym-footer justify-content-end mt-3">
      <button
        v-if="last_page - 1 !== index_soal && status_pengerjaan === 0"
        class="mym-btn mym-bg-primary"
        type="button"
        @click="nextSoal(1)"
      >
        Selanjutnya
        <i class="fas fa-chevron-right ms-1"></i>
      </button>
      <button
        v-if="last_page - 1 === index_soal || status_pengerjaan === 1"
        class="mym-btn mym-bg-success"
        type="button"
        @click="$emit('modalProgressFinal')"
        style="width: 200px"
      >
        Selesai
        <i class="fas fa-check ms-1"></i>
      </button>
    </div>

    <!-- MODAL HISTORY JAWABAN -->
    <b-modal
      v-model="modalHistoryJawaban"
      hide-footer
      title="List History Jawaban"
      dialog-class="modal-xl"
    >
      <ModalHistoryJawaban
        v-if="modalHistoryJawaban"
        @jawaban-selected="handleJawabanSelected"
        :idJadwal="idJadwal"
        :idJadwalPeserta="idJadwalPeserta"
        :idsoal="currentQuestion.idsoal"
        :refreshTable="refreshTable"
      />
    </b-modal>
  </div>
</template>

